import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";
import {TranslateService} from "@ngx-translate/core";
import { GlobalDataService } from '../../shared-services/global-data.service';

@Component({
    selector: 'app-remote',
    templateUrl: './remote.component.html',
    styleUrls: ['./remote.component.scss']
})
export class RemoteComponent implements OnInit {


    constructor(private route: ActivatedRoute,
                private translateService: TranslateService,
                private globalDataService:GlobalDataService,
                private router: Router) {
        this.route.paramMap.subscribe((params) => {
            const language = params.get("lang");
            if (language) {
                this.translateService.setDefaultLang(language);
                this.translateService.use(language);
            } else {
                const defaultLang = this.translateService.currentLang;
                this.router.navigate([this.globalDataService.getRemoteContext()+'/' + defaultLang + '/landing']);
            }
        })
    }

    ngOnInit(): void {

    }

}
